<template>
  <CRow>
    <CCol col="12" md="7">
      <CCard>
        <CCardHeader>
          <p>
            <img src="img/cow 4.svg" style="width: 20px" />&nbsp; AI Service
          </p>
        </CCardHeader>

        <CCardBody>
          <CDataTable
            :items="speciesItem"
            :fields="fields"
            pagination
            clickable-rows
            hover
            @row-clicked="rowClicked"
            caption="Species"
          />
        </CCardBody>
      </CCard>
    </CCol>
    <CCol col="6" md="5">
      <CCard>
        <CCardHeader>
          <p>
            <img src="img/cow 4.svg" style="width: 20px" /> &nbsp;AI Service
            Details
          </p>
        </CCardHeader>
        <CCardBody>
          <CForm>
            <CInput
              label="Date of Heat"
              type="date"
              horizontal
              autocomplete="name"
              id="speciesCode"
              name="speciesCode"
              v-model="aiHeatDate"
            />
            <CInput
              label="service Type"
              horizontal
              autocomplete="name"
              v-model="aiServiceType"
            />
            <CInput
              label="sire Ear TagNo"
              horizontal
              autocomplete="name"
              id="speciesCode"
              name="speciesCode"
              v-model="aiSireEarTagNo"
            />
            <CInput
              label="Insaminator"
              horizontal
              autocomplete="name"
              v-model="aiInseminator"
            />
            <CInput
              label="Total Dose"
              horizontal
              autocomplete="name"
              v-model="aiTotalDose"
            />
            <CInput
              label="Ticken Id"
              horizontal
              autocomplete="name"
              v-model="aiTicketId"
            />
          </CForm>
        </CCardBody>
        <CCardFooter>
          <CButton
            color="info"
            style="width: 100px"
            v-if="addButton"
            @click="addSpecies"
          >
            <CIcon name="cilPencil" />&nbsp;Add </CButton
          >&nbsp;
          <CButton
            color="success"
            style="width: 100px"
            v-if="saveButton"
            @click="updateSpecies"
          >
            <CIcon name="cilCheck" />&nbsp;Save </CButton
          >&nbsp;
          <CButton
            color="success"
            style="width: 100px"
            v-if="EditsaveButton"
            @click="addSpecies"
          >
            <CIcon name="cilCheck" />&nbsp;Save </CButton
          >&nbsp;
          <CButton
            color="danger"
            style="width: 100px"
            v-if="deleteButton"
            @click="deleteSpecies"
          >
            <CIcon name="cilXCircle" />&nbsp;Delete
          </CButton>
          &nbsp;
          <CButton
            color="secondary"
            style="width: 100px"
            v-if="cancelButton"
            @click="Cancelspecies"
          >
            <CIcon name="cilWarning" />&nbsp;Cancel
          </CButton>

          <CButton color="info" v-if="addnewButton" @click="addnewspecies">
            <CIcon name="cilPencil" />&nbsp;Add New
          </CButton>
        </CCardFooter>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import CTableWrapper from "../../../tables/Table";
import { APIService } from "../../../../apiservice.js";
import Swal from "sweetalert2";
import AppVue from "../../../../App.vue";
export default {
  components: { CTableWrapper },
  data() {
    return {
      fields: [
        {
          key: "aiHeatDate",
          label: "HeatDate",
          sortable: true,
        },
        {
          key: "aiServiceType",
          label: "ServiceType",
          sortable: true,
          _style: "width:30%",
        },
        {
          key: "aiSireEarTagNo",
          label: "EarTagNo",
          sortable: true,
          _style: "width:30%",
        },
        {
          key: "aiInseminator",
          label: "Inseminator",
          sortable: true,
        },
        {
          key: "aiTotalDose",
          label: "TotalDose",
          sortable: true,
        },
        {
          key: "aiTicketId",
          label: "TicketId",
          sortable: true,
        },
      ],

      aiHeatDate: "",
      aiServiceType: "",
      aiSireEarTagNo: "",
      pdInseminator: "",
      aiTotalDose: "",
      aiTicketId: "",
      speciesItem: [],
      editSpecies: [],
      addButton: false,
      saveButton: false,
      deleteButton: false,
      addnewButton: true,
      cancelButton: false,
      EditsaveButton: false,
    };
  },
  methods: {
    getserviceList() {
      APIService.serviceList().then((res) => {
        if (res.status == 200) {
          this.speciesItem = res.data;
        }
      });
    },
    rowClicked(item, index, column, e) {
      this.editSpecies = item;
      this.aiHeatDate = item.aiHeatDate;
      this.aiServiceType = item.aiServiceType;
      this.aiSireEarTagNo = item.aiSireEarTagNo;
      this.aiInseminator = item.aiInseminator;
      this.aiTotalDose = item.aiTotalDose;
      this.aiTicketId = item.aiTicketId;
      this.addButton = false;
      this.saveButton = true;
      this.deleteButton = true;
      this.cancelButton = false;
      this.addnewButton = true;
      this.EditsaveButton = false;
    },
    addnewspecies() {
      this.aiHeatDate = "";
      this.aiServiceType = "";
      this.aiSireEarTagNo = "";
      this.aiInseminator = "";
      this.aiTotalDose = "";
      this.aiTicketId = "";
      this.addButton = false;
      this.saveButton = false;
      this.deleteButton = false;
      this.cancelButton = true;
      this.addnewButton = false;
      this.EditsaveButton = true;
      return this.getserviceList();
    },
    Cancelspecies() {
      this.aiHeatDate = "";
      this.aiServiceType = "";
      this.aiSireEarTagNo = "";
      this.aiInseminator = "";
      this.aiTotalDose = "";
      this.aiTicketId = "";
      this.addButton = false;
      this.saveButton = false;
      this.deleteButton = false;
      this.cancelButton = false;
      this.addnewButton = true;
      (this.EditsaveButton = false), this.getserviceList();
    },

    addSpecies() {
      let aiHeatDate = this.aiHeatDate;
      let aiServiceType = this.aiServiceType;
      let aiSireEarTagNo = this.aiSireEarTagNo;
      let aiInseminator = this.aiInseminator;
      let aiTotalDose = this.aiTotalDose;
      let aiTicketId = this.aiTicketId;
      let data = {
        aiHeatDate,
        aiServiceType,
        aiSireEarTagNo,
        aiInseminator,
        aiTotalDose,
        aiTicketId,
      };
      APIService.saveServices(data).then((res) => {
        if (res.status == 200) {
          this.aiHeatDate = "";
          this.aiServiceType = "";
          this.aiSireEarTagNo = "";
          this.aiInseminator = "";
          this.aiTotalDose = "";
          this.aiTicketId = "";
          this.getserviceList();
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Data Saved Successfully",
            showConfirmButton: false,
            timer: 2000,
          });
        }
      });
    },
    updateSpecies() {
      let aiHeatDate = this.aiHeatDate;
      let aiServiceType = this.aiServiceType;
      let aiSireEarTagNo = this.aiSireEarTagNo;
      let aiInseminator = this.aiInseminator;
      let aiTotalDose = this.aiTotalDose;
      let aiTicketId = this.aiTicketId;
      let value = {
        aiHeatDate,
        aiServiceType,
        aiSireEarTagNo,
        aiInseminator,
        aiTotalDose,
        aiTicketId,
      };
      let data = { animalId, value };
      APIService.servicesUpdate(data).then((res) => {
        if (res.status == 200) {
          this.aiHeatDate = "";
          this.aiServiceType = "";
          this.aiSireEarTagNo = "";
          this.aiInseminator = "";
          this.aiTotalDose = "";
          this.aiTicketId = "";
          this.addButton = false;
          this.saveButton = false;
          this.deleteButton = false;
          this.cancelButton = false;
          this.addnewButton = true;
          this.getserviceList();
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Data Saved Successfully",
            showConfirmButton: false,
            timer: 2000,
          });
        }
      });
    },
    deleteSpecies() {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });

      swalWithBootstrapButtons
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, delete it!",
          cancelButtonText: "No, cancel!",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.value) {
            swalWithBootstrapButtons.fire(
              "Deleted!",
              "Your file has been deleted.",
              "success"
            );
            this.delete();
          } else if (
            /* Read more about handling dismissals below */
            result.dismiss === Swal.DismissReason.cancel
          ) {
            swalWithBootstrapButtons.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    },

    delete() {
      let id = this.editSpecies._id;
      let data = { id };
      APIService.serviceDelete(data).then((res) => {
        if (res.status == 200) {
          this.aiHeatDate = "";
          this.aiServiceType = "";
          this.aiSireEarTagNo = "";
          this.aiInseminator = "";
          this.aiTotalDose = "";
          this.aiTicketId = "";
          this.addButton = false;
          this.saveButton = false;
          this.deleteButton = false;
          this.cancelButton = false;
          this.addnewButton = true;
          (this.EditsaveButton = false), this.getserviceList();
        }
      });
    },
  },
  created() {
    this.getserviceList();
  },
};
</script>
<style scoped>
tbody > tr > :nth-child(1) {
  color: red;
  width: 200px;
  text-align: center;
}
.table-responsive {
  display: block;
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  border: inset;
}
</style>